import React, { Component } from "react";
import { packagesData } from "../../data/loaders";
import { ProcessPackageData } from "../../data/process";
import StudentTable from "../core/StudentTable";
import BackButton from "../core/BackButton";
import { PageWrapper } from "./LessonDashboard";
import SectionHeader from "../core/style/SectionHeader";
const headers = [
  "Packages Detail",
  "Lessons Purchased",
  "Lessons Taken",
  "Lessons Scheduled",
  "Lessons Remaining",
  "Date of Last Lesson",
  "Date of Next Lesson"
];

class PackagesDashboard extends Component {
  state = {
    data: null,
    loading: true
  };
  async componentDidMount() {
    this.props.updateMenu("packages", "Packages / Plans");
    const apiData = await packagesData();
    const data = ProcessPackageData(apiData);

    this.setState({ data, loading: false });
  }
  render() {
    if (this.state.loading) return <h4>Loading Classes </h4>;
    return (
      <PageWrapper>
        <BackButton path="/app/student-dashboard" />
        <SectionHeader>Package Details</SectionHeader>
        {this.state.data.length > 0 ? (
          <StudentTable headers={headers} data={this.state.data} />
        ) : (
          <p>No Package details available.</p>
        )}
      </PageWrapper>
    );
  }
}

export default PackagesDashboard;
